// extracted by mini-css-extract-plugin
export var fullHeightState = "_5e-7";
export var headerCell = "_5e-1";
export var loadingStateCell = "_5e-4";
export var rowWrapper = "_5e-3";
export var standaloneTable = "_5e-8";
export var standaloneTableWithBodyFill = "_5e-9";
export var stateCell = "_5e-5";
export var table = "_5e-0";
export var tableBodyFiller = "_5e-6";
export var white = "_5e-2";